import View from './Header';
import enhancer from './Header.enhancer';

const Header = enhancer(View);

export default Header;
